import React from 'react';
import styles from './styles.module.scss';
import { Board } from '../../../components/Board';
import { NavButton } from '../../../components/NavButton';

type Student = {
    id: number;
    name: string;
    image?: { url: string };
    correct: number;
};

type LeaderboardProps = {
    students: Student[];
};

export const Leaderboard: React.FC<LeaderboardProps> = ({ students }) => {
    const normalized = [...students].map(s => ({
        ...s,
        correct: s.correct ?? 0
    }));

    const topStudents = [...normalized].sort((a, b) => b.correct - a.correct);
    return (
        <div className={styles.leaderboard}>
            <NavButton
                route='/manager'
                direction='left'
                style={{ left: '0.4vw', top: '2vw', zIndex: 20 }}
            />
            <Board wrapperClass={styles.board}>
                <h2 className={styles.titleL}>🏆 Classificação 🏆</h2>
                <ol className={styles.list}>
                    {topStudents.map((student, index) => (
                        <li
                            key={student.id}
                            className={`${styles.listItem} ${index === 0 ? styles.first : ''} ${
                                index === 1 ? styles.second : ''
                            } ${index === 2 ? styles.third : ''}`}
                        >
                            <span className={styles.rank}>#{index + 1}</span>
                            <img
                                src={student.image?.url}
                                alt={student.name}
                                className={styles.avatarL}
                            />
                            <span className={styles.nameL}>{student.name}</span>
                            <span className={styles.score}>{student.correct} Pontos</span>
                        </li>
                    ))}
                </ol>
            </Board>
        </div>
    );
};
